import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=6e6a62ea"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports